export default __webpack_public_path__ + "static/media/Welcome .204dc638.svg";